export default defineNuxtPlugin(async (nuxtApp) => {
  const auth = useAuthStore()
  const cart = useCartStore()
  const fav = useFavoritesStore()

  if (window.location.pathname.endsWith('/oauth/callback')) return
  await auth.init().catch(() => undefined)

  const name = String(nuxtApp._route?.name || '')
  const isFavorites = name.startsWith('favorites')

  const loadCustomerData = () => Promise.allSettled([
      cart.loadCart(),
      auth.isAuthenticated && !isFavorites ? fav.load() : Promise.resolve(),
  ])
  // Restore the session before user actions; defer the badges on public SSR pages.
  if (nuxtApp.payload.serverRendered) onNuxtReady(loadCustomerData)
  else await loadCustomerData()
})
